import React from 'react';
import { ArrowLeft, CalendarDays, Settings, ChevronRight, BellRing, Activity, Cpu, Users, ShieldCheck, Wrench } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PortalGuruPengaturan: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 pb-20 font-sans">
            {/* Header */}
            <div className="bg-white border-b sticky top-0 z-30 shadow-sm">
                <div className="flex items-center justify-between px-4 py-3">
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => navigate('/portal-guru')}
                            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                        >
                            <ArrowLeft className="w-5 h-5 text-gray-600" />
                        </button>
                        <div>
                            <h1 className="text-lg font-bold text-gray-900 leading-tight">Pengaturan Sistem</h1>
                            <p className="text-xs text-gray-500 font-medium">Super Admin</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-4 max-w-3xl mx-auto space-y-6 mt-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/* Tahun Ajaran Card */}
                    <button
                        onClick={() => navigate('/portal-guru/admin/pengaturan/tahun-ajaran')}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:border-brand-primary hover:shadow-md transition-all group text-left"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-blue-50 p-2.5 rounded-lg group-hover:bg-brand-primary/10 transition-colors">
                                <CalendarDays className="w-6 h-6 text-blue-600 group-hover:text-brand-primary transition-colors" />
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-brand-primary transition-colors" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1">Tahun Ajaran</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Kelola periode aktif tahun ajaran untuk seluruh kegiatan akademik dan non-akademik.</p>
                    </button>

                    {/* Pengaturan Alert Indisipliner Card */}
                    <button
                        onClick={() => navigate('/portal-guru/admin/pengaturan/alert-indisipliner')}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:border-red-500 hover:shadow-md transition-all group text-left"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-red-50 p-2.5 rounded-lg group-hover:bg-red-100 transition-colors">
                                <BellRing className="w-6 h-6 text-red-500 group-hover:text-red-600 transition-colors" />
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-red-500 transition-colors" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1">Alert Indisipliner</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Kelola batas ambang batas (threshold) untuk peringatan santri sakit dan bolos kelas/tahfidz.</p>
                    </button>

                    {/* Pengaturan Ekskul Lintas Jenjang Card */}
                    <button
                        onClick={() => navigate('/portal-guru/admin/pengaturan/akses-ekskul')}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:border-emerald-500 hover:shadow-md transition-all group text-left"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-emerald-50 p-2.5 rounded-lg group-hover:bg-emerald-100 transition-colors">
                                <Activity className="w-6 h-6 text-emerald-500 group-hover:text-emerald-600 transition-colors" />
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-500 transition-colors" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1">Akses Ekskul</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Kelola hak akses jenjang mana saja yang bisa dikelola oleh guru (Waka Kesiswaan).</p>
                    </button>

                    <button
                        onClick={() => navigate('/portal-guru/admin/pengaturan/ai')}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:border-brand-primary hover:shadow-md transition-all group text-left"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-indigo-50 p-2.5 rounded-lg group-hover:bg-indigo-100 transition-colors">
                                <Cpu className="w-6 h-6 text-indigo-600" />
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-indigo-600 transition-colors" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1 group-hover:text-indigo-600 transition-colors">Pengaturan AI</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Konfigurasi jenis model AI yang digunakan untuk setiap fitur.</p>
                    </button>

                                        {/* Analisis Akses Card */}
                    <button
                        onClick={() => navigate('/portal-guru/admin/pengaturan/analisis-akses')}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:border-blue-500 hover:shadow-md transition-all group text-left"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-blue-50 p-2.5 rounded-lg group-hover:bg-blue-100 transition-colors">
                                <ShieldCheck className="w-6 h-6 text-blue-600 group-hover:text-blue-700 transition-colors" />
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1 group-hover:text-blue-600 transition-colors">Analisis & Duplikat Akses</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Kelola dokumen ganda dan lihat statistik distribusi hak akses menu guru.</p>
                    </button>

                    {/* Setting Role Card */}
                    <button
                        onClick={() => navigate('/portal-guru/admin/pengaturan/role')}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:border-brand-primary hover:shadow-md transition-all group text-left"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-purple-50 p-2.5 rounded-lg group-hover:bg-purple-100 transition-colors">
                                <Users className="w-6 h-6 text-purple-600 group-hover:text-purple-700 transition-colors" />
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1 group-hover:text-purple-600 transition-colors">Setting Role</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Atur role (peran) sistem untuk akun staf atau guru tertentu.</p>
                    </button>

                    {/* Mode Maintenance Card */}
                    <button
                        onClick={() => navigate('/portal-guru/admin/pengaturan/maintenance')}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:border-amber-500 hover:shadow-md transition-all group text-left"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-amber-50 p-2.5 rounded-lg group-hover:bg-amber-100 transition-colors">
                                <Wrench className="w-6 h-6 text-amber-600 group-hover:text-amber-700 transition-colors" />
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-amber-600 transition-colors" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1 group-hover:text-amber-600 transition-colors">Mode Maintenance</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Tutup sementara aplikasi untuk semua pengguna selain Super Admin, langsung atau terjadwal.</p>
                    </button>

                    {/* Placeholder for future settings */}
                    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 opacity-50 cursor-not-allowed text-left">
                        <div className="flex items-center justify-between mb-3">
                            <div className="bg-gray-50 p-2.5 rounded-lg">
                                <Settings className="w-6 h-6 text-gray-500" />
                            </div>
                        </div>
                        <h3 className="font-bold text-gray-900 mb-1">Pengaturan Lainnya</h3>
                        <p className="text-xs text-gray-500 leading-relaxed">Fitur pengaturan tambahan akan segera hadir di versi mendatang.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
